export default __webpack_public_path__ + "static/media/v10.ba5c78ae.svg";